import { render, staticRenderFns } from "./golongandeposito.vue?vue&type=template&id=4fd9f00c&scoped=true"
import script from "./golongandeposito.vue?vue&type=script&lang=js"
export * from "./golongandeposito.vue?vue&type=script&lang=js"
import style0 from "./golongandeposito.vue?vue&type=style&index=0&id=4fd9f00c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd9f00c",
  null
  
)

export default component.exports